module.exports = __webpack_public_path__ + "img/changjing.5ef3d629.webp";